"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoadsideNumberDto = void 0;
const ManufacturerDto_1 = require("../manufacturers/ManufacturerDto");
const LocationDto_1 = require("../locations/LocationDto");
class RoadsideNumberDto {
    constructor(params) {
        this.name = "";
        this.number = "";
        this.createdAt = "";
        this.updatedAt = "";
        this.typeOfIcon = "";
        this.iconFileName = "";
        this.iconContentType = "";
        this.iconUpdatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.manufacturerId = params.manufacturerId;
        this.name = params.name;
        this.number = params.number;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        this.locationId = params.locationId;
        this.typeOfIcon = params.typeOfIcon;
        this.manufacturerIconId = params.manufacturerIconId;
        this.iconFileName = params.iconFileName;
        this.iconContentType = params.iconContentType;
        this.iconFileSize = params.iconFileSize;
        this.iconUpdatedAt = params.iconUpdatedAt;
        this.position = params.position;
        if (params.location !== undefined) {
            this.location = params.location === null ?
                null :
                new LocationDto_1.LocationDto(params.location);
        }
        if (params.manufacturer !== undefined) {
            this.manufacturer = params.manufacturer === null ?
                null :
                new ManufacturerDto_1.ManufacturerDto(params.manufacturer);
        }
    }
}
exports.RoadsideNumberDto = RoadsideNumberDto;
//# sourceMappingURL=RoadsideNumberDto.js.map